import { ProgressBar } from 'react-bootstrap';
import React from 'react';
import { BackButton } from '../../../../../../shared/components/button/BackButton';

interface IProgressBarCampaignProps {
    title: string;
    percent: number;
    showBackButton?: boolean;
}

export const ProgressBarCampaign = ({ title, percent, showBackButton = false }: IProgressBarCampaignProps) => {
    return (
        <>
            <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center">
                    {showBackButton && <BackButton />}
                    <h4 className="font-weight-bold mb-0">{title}</h4>
                </div>
                <h4 className="font-weight-bold text-primary">{percent}%</h4>
            </div>
            <ProgressBar
                role="progressbar"
                variant="primary"
                className="progress-sm w-100 bg-gray"
                now={percent}
                max={100}
            />
        </>
    );
};
